import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Link,
  Typography,
  Avatar,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import LanguageIcon from '@material-ui/icons/Language';
import FooterImage from './Icons/footer_logo.png';
import I18n from '../../config/locales';
import { getValue, removeKey, setValue } from '../../utils/localStorage';
import { getCountryBasedLink, forwardTo } from '../../utils/helper';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import feature from '../../utils/feature';
import passedCheck from '../../../image/tickcheck.png';
import failedCheck from '../../../image/errorcheck.png';
import warningimg from '../../../image/warning.png';
import ellipse from '../../../image/Ellipse.png';

var healthCT;

const constantLocaleList = isFromLogin => [
  {
    key: 'en',
    label: 'English'
  },
  {
    key: 'en-AU',
    label: 'English (Australia)'
  },
  {
    key: 'fr',
    label: 'Français'
  },
  {
    key: 'it',
    label: 'Italiano'
  },
  {
    key: 'de',
    label: 'Deutsch'
  },
  {
    key: 'es',
    label: 'Español'
  },
  {
    key: 'nl',
    label: 'Nederlands'
  },
  {
    key: 'ja',
    label: '日本語'
  },
  ...(isFromLogin
    ? [
      {
        key: 'pt',
        label: 'Português'
      },
      {
        key: 'pl',
        label: 'Polski'
      }
    ]
    : [])
];
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(6, 4.5),
    marginTop: 'auto',
    justifyContent: 'space-between'
  },
  quotesExpandedRoot: {
    width: 'calc(100% - 432px)'
  },
  columnDirection: {
    display: 'flex',
    flexDirection: 'column'
  },
  timestampsection: {
    display: 'flex',
    fontSize: '13px',
    padding: '5px 0'
  },
  ctsiteid: {
    paddingRight: '10px',
    borderRight: '1px solid white'
  },
  cttimestamp: {
    fontSize: '13px',
    padding: '5px 0'
  },
  CTmeterSerialNum: {
    paddingLeft: '10px'
  },
  privacyTerms: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    '& > p': {
      paddingRight: theme.spacing(1)
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  link: {
    color: `${theme.palette.tertiary.main} !important`,
    cursor: 'pointer !important',
    padding: `${theme.spacing(0, 1)} !important`
  },
  removePaddingPrivacy: {
    [theme.breakpoints.down('xs')]: {
      paddingLeft: `${theme.spacing(0)} !important`
    }
  },
  copyRights: {
    fontSize: '12px !important'
  },
  footerLogo: {
    height: theme.spacing(3.5),
    width: theme.spacing(15.5),
    minHeight: theme.spacing(3.5),
    marginRight: theme.spacing(2.5)
  },
  modalheathcheck: {
    position: 'fixed',
    bottom: 0,
    right: '25px',
    width: '400px',
    height: 'auto',
    minHeight: '200px',
    backgroundColor: '#fffcfc',
    zIndex: '10000000000',
    boxShadow: '20px 20px 50px grey',
    paddingBottom: '100px'
  },
  healthcheck_header: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#f2731e',
    alignItems: 'center',
    padding: '20px 15px 15px 15px',
    color: 'white'
  },
  closehealthcheck: {
    fontSize: '25px',
    cursor: 'pointer',
    fontWeight: '300'
  },
  checklist_section: {
    display: 'flex',
    padding: '10px 20px'
  },
  checklistwaitingimg: {
    height: '22px'
  },
  checklist_title: {
    marginLeft: '10px',
    color: '#302e2e',
    fontSize: '15px'
  },

  modal_content_healthcheck: {
    maxHeight: '650px',
    height: 'auto',
    overflowX: 'hidden',
    overflowY: 'scroll'
  },
  listSpanwarningStyle: {
    marginLeft: '7px',
    marginTop: '-4px',
    color: '#db4747'
  },
  nocttext: {
    textAlign: 'center',
    fontSize: '14px',
    color: '#393535',
    marginTop: '2rem'
  },
  prod_ct_hidedetails: {
    fontSize: '12px',
    paddingLeft: '50px',
    paddingBottom: '10px',
    color: '#468cc7',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  health_check_error_content: {
    display: 'block'
  },

  prod_ct_warning_section: {
    display: 'flex',
    color: '#e85353',
    fontSize: '13px',
    paddingLeft: '50px',
    paddingRight: '15px'
  },
  checklist_nodata: {
    display: 'inline',
    fontSize: '14px',
    marginLeft: '10px',
    marginTop: '5px',
    color: '#726c6c'
  },
  prod_ct_moredetails_section: {
    paddingLeft: '52px',
    paddingRight: '15px',
    fontSize: '13px',
    paddingTop: '15px',
  },
  listSectionStyle: {
    display: 'flex',
    padding: '8px 0'
  },
  warningimgStyle: {
    height: '15px',
  },
  ellipseimgStyle: {
    height: '8px',
  },
  footerContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  listSpanStyle: {
    marginLeft: '12px',
    marginTop: '-4px',
    color: '#6b6666'
  },
  languageSwitchButton: {
    padding: theme.spacing(0, 1.5),
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& p': {
      fontSize: 14,
      marginLeft: theme.spacing(0.5)
    },
    '& svg': {
      width: theme.spacing(2)
    }
  },
  footerProdCt: {
    position: 'fixed',
    bottom: '0px',
    width: '100%',
    backgroundColor: 'white',
    zIndex: '10000000000',
    padding: '25px 10px 25px 15px',
    border: '1px solid #fff5f5',
    display: 'flex',
    justifyContent: 'space-around'
  },
  polarity_extrainfo: {
    fontSize: '13px',
    marginLeft: '52px',
    marginTop: '5px'
  },
  checklist_section_pending: {
    display: 'flex',
    padding: '10px 20px'
  },
  loaderct: {
    border: '4px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '3px solid #f2731e',
    width: '15px',
    height: '15px',
    animation: 'spin 2s linear infinite'
  },
  checklist_title: {
    marginLeft: '10px',
    color: '#302e2e',
    fontSize: '15px'
  },
  checkListErrorDiv: {
    textAlign: 'center',
    fontSize: '14px',
    color: '#393535',
    position: 'absolute',
    left: '22%',
    top: '47%'
  },
  latchesTimeOutDiv: {
    color: '#393535',
    fontSize: '12px',
    marginLeft: '10px',
    marginTop: '5px',
  },
  circuitBranchesTimeOutDiv: {
    color: '#393535',
    fontSize: '12px',
    marginLeft: '10px',
    marginTop: '5px',
  },
  reversepolarity_config_btn: {
    color: '#f2731e',
    padding: '0.2em 0.5em !important',
    borderRadius: '0.4em',
    margin: '0.8em 0.4em 0.8em 0.5em',
    display: 'inline-block',
    fontWeight: '500',
    textAlign: 'center',
    cursor: 'pointer',
    background: 'none',
    border: '1px solid #f2731e',
    height: '32px',
    fontSize: '14px',
    marginLeft: '52px'
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 0
  },
  checklist_extrainfo: {
    fontSize: '12px',
    marginLeft: '10px',
    marginTop: '5px'
  },
  healthcheck_header_text: {
    fontSize: '18px',
    color: 'white',
    fontWeight: '600',
    paddingBottom: '5px'

  },
  optionWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing(0.5, 0)
  },
  selectedLocale: {
    color: theme.palette.primary.main,
    marginLeft: theme.spacing(0.5)
  },
  locale: {
    marginLeft: theme.spacing(3.5)
  },
  disablePointer: {
    pointerEvents: 'none'
  },
  privacyTermsWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& a:first-child': {
      paddingLeft: 0
    }
  },
  backdrop: {
    zIndex: 11,
    color: theme.palette.primary.main
  }
}));

const Footer = props => {
  const classes = useStyles();
  const {
    locale = 'en',
    getAccountData = () => { },
    companyId,
    currentlySending = false,
    isQuotesExpanded,
    isFromLogin = false,
    featureList,
    availableLocales
  } = props;
  const [showLanguageSwitchPopup, toggleLanguageSwitchPopup] = useState(false);
  const [localeList, setLocaleList] = useState(availableLocales || constantLocaleList(isFromLogin));
  const [selectedLanguage, setSelectedLanguage] = useState(localeList.find(data => data.key === locale));
  const pathName = window.location.pathname;
  const splitPathName = pathName.split('/');
  const pathArray = [];
  splitPathName.forEach(path => path && pathArray.push(path));
  let isPortugueseEnabled = false;
  let isPolishEnabled = false;

  useEffect(
    () => {

      if (!isEmpty(featureList)) {
        isPortugueseEnabled = feature.isFeatureEnabled('PORTUGUESE_TRANSLATION');
        isPolishEnabled = feature.isFeatureEnabled('POLISH_TRANSLATION');
      }
    },
    [featureList]
  );

  useEffect(
    () => {
      if (!availableLocales) {
        const newLocaleList = [];
        if (isPortugueseEnabled && !constantLocaleList(isFromLogin).find(data => data.key === 'pt')) {
          newLocaleList.push({
            key: 'pt',
            label: 'Português'
          });
        }

        if (isPolishEnabled && !constantLocaleList(isFromLogin).find(data => data.key === 'pl')) {
          newLocaleList.push({
            key: 'pl',
            label: 'Polski'
          });
        }
        setLocaleList([...constantLocaleList(isFromLogin), ...newLocaleList]);
      } else {
        setLocaleList(availableLocales);
      }
    },
    [isPortugueseEnabled, isPolishEnabled, locale, featureList, availableLocales]
  );

  useEffect(
    () => {
      const selectedLanguage = localeList.find(data => data.key === locale);
      setSelectedLanguage(selectedLanguage);
    },
    [localeList, locale]
  );

  useEffect(
    () => {
      const localeKey = getValue('locale_id') || '';

      if (!currentlySending && !isEmpty(locale) && locale !== localeKey) {
        removeKey('locale_id');
        setValue('locale_id', locale);
        window.location.reload();
      }
    },
    [currentlySending, locale]
  );

  useEffect(() => {

    healthCT = JSON.parse(localStorage.getItem("healthcheckresult") || "[]");
  }, []);
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  function getLocaleId() {

    const locale = getCookie("locale_id");

    let localeId = '16375'; //English
    switch (locale) {
      case 'de':
        localeId = '16380'; //German
        break;
      case 'fr':
        localeId = '16376'; //French
        break;
      case 'it':
        localeId = '16379'; //Italian
        break;
      case 'nl':
        localeId = '16378'; //Dutch
        break;
      case 'es':
        localeId = '16377'; //Spanish
        break;
      case 'pl':
        localeId = '16382'; //Spanish
        break;
      case 'pt':
        localeId = '16381'; //Spanish
        break;
      case 'ja':
        localeId = '16020';   //Japanese
        break;
      default:
        break;
    }
    return localeId;
  }
  const switchLanguage = localeData => {
    if (isFromLogin) {
      setLocale(localeData, isFromLogin);
    } else {
      getAccountData({
        body: { account: { locale: localeData.key, company_id: companyId } },
        successCbk: () => setLocale(localeData, false),
        isUpdate: true,
        hideSnakbar: true
      });
    }
  };
  const setLocale = (localeData, isFromLogin = false) => {
    toggleLanguageSwitchPopup(false);
    removeKey('locale_id');
    setValue('locale_id', localeData.key);
    isFromLogin && forwardTo(`registration?locale=${localeData.key}`);
    window.location.reload();
  };
  const hideshowFunction = () => {
    console.log("hideshowFunction");
    var x = document.getElementById("health_check_error_content_id");
    if (x.style.display === "none") {
      x.style.display = "block";
      document.getElementById('prod_ct_hidedetails_id').innerHTML = I18n.t('footer.production_ct.hide_details');
    } else {
      x.style.display = "none";
      document.getElementById('prod_ct_hidedetails_id').innerHTML = I18n.t('footer.production_ct.show_details');
    }


  }
  const hideshowFunction1 = () => {
    console.log("hideshowFunction");
    var x1 = document.getElementById("health_check_error_content_id1");

    if (x1.style.display === "none") {
      x1.style.display = "block";
      document.getElementById('prod_ct_hidedetails_id1').innerHTML = I18n.t('footer.production_ct.hide_details');
    } else {
      x1.style.display = "none";
      document.getElementById('prod_ct_hidedetails_id1').innerHTML = I18n.t('footer.production_ct.show_details');
    }

  }
  const handleFeedbackBtn = () => {
    !localStorage.getItem('feedbackGiven') && window.fby.push(['showForm', getLocaleId()]);
    localStorage.setItem("productionCTModal", "disabled");

    if (localStorage.getItem("productionCTModal") === "disabled") {
      document.getElementById('healthcheckModal').style.display = 'none';
    }
    localStorage.removeItem("healthcheckresult");
    localStorage.removeItem("productionCTModal");
    localStorage.removeItem("healthcheckLoaderone");
    localStorage.removeItem("healthcheckLoadertwo");
    localStorage.removeItem("healthcheckLoader");
    localStorage.removeItem("helathcheckCTTwo");
    localStorage.removeItem("helathcheckCTOne");
    localStorage.removeItem("site_id_store");
    localStorage.removeItem("ProdCtLoader");
    localStorage.removeItem("ProductionCTMeter");
    localStorage.removeItem("CTTimeStamp");
    localStorage.removeItem("CTsiteID");
    localStorage.removeItem("latchesinreversenodata");
    localStorage.removeItem("branchcircuitnodata");
  }

  if (!localStorage.getItem('feedbackGiven')) {
    if (window && window.FBY && window.FBY.config) {
      window.FBY.config.onclose = function (a) {
        localStorage.setItem('feedbackGiven', true);
      };
      window.FBY.config.onsubmit = function (a) {
        localStorage.setItem('feedbackGiven', true);
      };
    }
  }
  const showreverseCtPlarity = () => {
    var siteid = localStorage.getItem("CTsiteID");
    var meterid = localStorage.getItem('meter_ctid');
    window.location.href = `/systems/${siteid}/meters/${meterid}?reverseCt=true`;
  }
  return (
    <div>
      {localStorage.getItem("productionCTModal") === "enabled" &&
        <div id="healthcheckModal" className={classes.modalheathcheck}>
          <div className={classes.healthcheck_header} >
            <div>
              <div className={classes.healthcheck_header_text} > {I18n.t('footer.production_ct.production_meter_verification')}</div>
              <div className={classes.timestampsection} >
                {localStorage.getItem("CTsiteID") && <div className={classes.ctsiteid} >{I18n.t('footer.production_ct.verify_ct_systemID')}:{localStorage.getItem("CTsiteID")}</div>}
                <div className={classes.CTmeterSerialNum}>{I18n.t('footer.production_ct.serial_no')}: {localStorage.getItem("meter_serialno")}</div>
              </div>
              {localStorage.getItem("CTTimeStamp") && <div className={classes.cttimestamp} >{I18n.t('footer.production_ct.verify_ct_timeStamp')}:{localStorage.getItem("CTTimeStamp")}</div>}
            </div>
            <div className={classes.closehealthcheck} onClick={() => handleFeedbackBtn()} >&times;</div>
          </div>
          {(() => {
            if ((localStorage.getItem("latchesInReverseError") === "show") && (localStorage.getItem("circuitBranchesError") === "show")) {
              return (
                <div>
                  <div className={classes.checklist_section_pending}>
                    <div className={classes.loaderct}></div>
                    <div>
                      <div className={classes.checklist_title}>{I18n.t('footer.production_ct.polarity_check')}</div>
                      <div className={classes.latchesTimeOutDiv}>{I18n.t('footer.production_ct.verify_ct_timeout')}</div>
                    </div>
                  </div>
                  <div className={classes.checklist_section_pending} >
                    <div className={classes.loaderct}></div>
                    <div>
                      <div className={classes.checklist_title}>{I18n.t('footer.production_ct.ct_missing_branch_check')}</div>
                      <div className={classes.checklist_extrainfo}>{I18n.t('footer.production_ct.test_only_valid_for_sunshine_hours')}</div>
                      <div className={classes.circuitBranchesTimeOutDiv}>{I18n.t('footer.production_ct.verify_ct_timeout')}</div>
                    </div>
                  </div>

                </div>

              )
            }
            else if (localStorage.getItem("checkListError") === "show") {
              return (
                <div className={classes.checkListErrorDiv}>
                  {I18n.t('footer.production_ct.verify_ct_timeout')}
                </div>
              )
            }
            else if (localStorage.getItem("latchesInReverseError") === "show") {
              return (<div className={classes.checklist_section_pending}>
                <div className={classes.loaderct}></div>
                <div>
                  <div className={classes.checklist_title}>{I18n.t('footer.production_ct.polarity_check')}</div>
                  <div className={classes.latchesTimeOutDiv}>{I18n.t('footer.production_ct.verify_ct_timeout')}</div>
                </div>
              </div>)
            }
            else if (localStorage.getItem("circuitBranchesError") === "show") {
              return (<div className={classes.checklist_section_pending} >
                <div className={classes.loaderct}></div>
                <div>
                  <div className={classes.checklist_title}>{I18n.t('footer.production_ct.ct_missing_branch_check')}</div>
                  <div className={classes.checklist_extrainfo}>{I18n.t('footer.production_ct.test_only_valid_for_sunshine_hours')}</div>
                  <div className={classes.circuitBranchesTimeOutDiv}>{I18n.t('footer.production_ct.verify_ct_timeout')}</div>
                </div>
              </div>)
            }

            else if (localStorage.getItem("circuitBranchesMultiphaseError") === "show") {
              return (<div className={classes.checklist_section_pending} >
                <div className={classes.loaderct}></div>
                <div>
                  <div className={classes.checklist_title}>{I18n.t('footer.production_ct.ct_missing_branch_check')}</div>
                  <div className={classes.checklist_extrainfo}>{I18n.t('footer.production_ct.test_only_valid_for_sunshine_hours')}</div>
                  <div className={classes.circuitBranchesTimeOutDiv}>{I18n.t('footer.production_ct.verify_ct_timeout')}</div>
                </div>
              </div>)
            }
            else {
              return (
                healthCT && healthCT.length > 0 ?
                  (
                    <div className={classes.modal_content_healthcheck} >
                      {healthCT && healthCT.map((value, index) => {
                        if (value.name === "latches_in_reverse") {
                          if (value.status === true) {
                            return (<div className={classes.checklist_section}>
                              <img src={passedCheck} className={classes.checklistwaitingimg} />
                              <div className={classes.checklist_title}>{I18n.t('footer.production_ct.polarity_check_passed')}</div>
                            </div>)
                          }
                          if (value.status === false) {
                            return (
                              <div class="mainsessionerror">
                                {localStorage.getItem("showReversePolarity") === "show" ? (
                                  <div className={classes.reversepolarity_section}>
                                    <div className={classes.polarity_extrainfo} >{I18n.t('footer.production_ct.prodct_reversepolarity_text')}</div>
                                    <button type="button" className={classes.reversepolarity_config_btn} onClick={() => showreverseCtPlarity()} >{I18n.t('footer.production_ct.prodct_reverse_polarity_btn')}</button>
                                  </div>
                                ) : ''}
                                <div className={classes.checklist_section}>
                                  <img src={failedCheck} className={classes.checklistwaitingimg} />
                                  <div>
                                    <div className={classes.checklist_title}>{I18n.t('footer.production_ct.polarity_check_failed')}{localStorage.getItem("latchesinreversenodata") === 'true' ? (<span className={classes.checklist_nodata}>({I18n.t('footer.production_ct.checlist_nodata')})</span>) : ''}</div>


                                  </div>
                                </div>
                                <div className={classes.prod_ct_hidedetails} id="prod_ct_hidedetails_id" onClick={() => hideshowFunction()} >{I18n.t('footer.production_ct.hide_details')}</div>
                                <div className={classes.health_check_error_content} id="health_check_error_content_id">
                                  <div className={classes.prod_ct_warning_section} >
                                    <img src={warningimg} className={classes.warningimgStyle} />
                                    <div className={classes.listSpanwarningStyle}>{I18n.t('footer.production_ct.reading_lower_than_expected')}</div>
                                  </div>
                                  <div className={classes.prod_ct_moredetails_section} >
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.pv_on_for_5_min')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.l1_wires_production_ct_message')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.blue_white_wires_position_message')}  (<a href='https://enphase.com/download/guidelines-current-transformer-ct-installation' target='_blank'>Guidelines for CT installation</a>)</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.wires_include_pv_generation_not_load_storage')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.l1_a_correct_phase_message')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.l1_phase_consistency_check_message')}</span></div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        }
                        else if (value.name === "missing_branch_circuits") {
                          if (value.status === true) {
                            return (
                              <div className={classes.checklist_section}>
                                <img src={passedCheck} className={classes.checklistwaitingimg} />
                                <div>
                                  <div className={classes.checklist_title}>{I18n.t('footer.production_ct.ct_no_missing_branch_circuit')}</div>
                                  <div className={classes.checklist_extrainfo}>{I18n.t('footer.production_ct.test_only_valid_for_sunshine_hours')}</div>
                                </div>
                              </div>
                            )
                          }
                          if (value.status === false) {
                            return (
                              <div class="mainsessionerror">
                                <div className={classes.checklist_section}>
                                  <img src={failedCheck} className={classes.checklistwaitingimg} />
                                  <div>
                                    <div className={classes.checklist_title}>{I18n.t('footer.production_ct.missing_branch_warning')} {localStorage.getItem("branchcircuitnodata") === 'true' ? (<span className={classes.checklist_nodata} >({I18n.t('footer.production_ct.checlist_nodata')})</span>) : ''}</div>

                                    <div className={classes.checklist_extrainfo}>{I18n.t('footer.production_ct.test_only_valid_for_sunshine_hours')}</div>
                                  </div>
                                </div>
                                <div className={classes.prod_ct_hidedetails} id="prod_ct_hidedetails_id1" onClick={() => hideshowFunction1()} >{I18n.t('footer.production_ct.hide_details')}</div>
                                <div className={classes.health_check_error_content} id="health_check_error_content_id1">
                                  <div className={classes.prod_ct_warning_section}>
                                    <img src={warningimg} className={classes.warningimgStyle} />
                                    <div className={classes.listSpanwarningStyle}>{I18n.t('footer.production_ct.reading_lower_than_expected')}</div>
                                  </div>
                                  <div className={classes.prod_ct_moredetails_section} >
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.pv_on_for_5_min')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.wires_include_all_pv_generation')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.branch_circuit_reverse_check')}</span></div>
                                    <div className={classes.listSectionStyle}><img src={ellipse} className={classes.ellipseimgStyle} /><span className={classes.listSpanStyle}>{I18n.t('footer.production_ct.storage_load_circuits_through_production_ct')}</span></div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        }
                      })}
                    </div>
                  )
                  : (
                    <div className={classes.nocttext}>{I18n.t('footer.production_ct.verify_ct_not_supported_for_device')}</div>
                  )
              )
            }
          })()}

        </div>
      }
      <footer className={localStorage.getItem("productionCTModal") === "enabled" ? classes.footerProdCt : clsx(classes.root, isQuotesExpanded && classes.quotesExpandedRoot)}>
        <Box className={classes.footerContainer}>
          <Box>
            <Link title={I18n.t('footer.imageTitle')} href="http://enphase.com/" target="_blank">
              <Avatar variant="square" className={classes.footerLogo} alt="enphase footer logo" src={FooterImage} />
            </Link>
          </Box>
          <Box className={classes.columnDirection}>
            <Box className={classes.privacyTerms}>
              <Typography className={classes.copyRights}>
                {I18n.t('footer.enphaseText', { currentYear: moment().year() })}
              </Typography>
              <Box className={classes.privacyTermsWrapper}>
                <Link
                  className={clsx(classes.link, classes.removePaddingPrivacy)}
                  href={getCountryBasedLink('privacy')}
                  target="_blank"
                >
                  {I18n.t('footer.privacy')}
                </Link>
                <Typography>|</Typography>
                <Link className={classes.link} href={getCountryBasedLink('terms')} target="_blank">
                  {I18n.t('footer.terms')}
                </Link>
              </Box>
            </Box>
            {props?.version && <Box className={classes.privacyTermsWrapper}>
              <Typography className={classes.copyRights}>
                v {props.version}
              </Typography>
            </Box>}
          </Box>
        </Box>
        <Box>
          <IconButton className={classes.languageSwitchButton} onClick={() => toggleLanguageSwitchPopup(true)}>
            <LanguageIcon color="primary" />
            <Typography>{get(selectedLanguage, 'label', '')}</Typography>
          </IconButton>
        </Box>
        <Dialog maxWidth="xs" fullWidth open={showLanguageSwitchPopup} onClose={() => toggleLanguageSwitchPopup(false)}>
          <DialogTitle disableTypography className={classes.titleWrapper}>
            <Typography variant="h6">{I18n.t('footer.language')}</Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={() => toggleLanguageSwitchPopup(false)}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {localeList.map((localeData, index) => {
              const isSelectedLocale = localeData.key === locale;
              const className = isSelectedLocale ? classes.selectedLocale : classes.locale;
              return (
                <Box
                  key={index}
                  onClick={() => switchLanguage(localeData)}
                  className={clsx(classes.optionWrapper, isSelectedLocale && classes.disablePointer)}
                >
                  {isSelectedLocale && <CheckIcon color="primary" />}
                  <Typography component="div" className={className}>
                    {localeData.label}
                  </Typography>
                </Box>
              );
            })}
          </DialogContent>
        </Dialog>
        {!isFromLogin &&
          currentlySending && (
            <Backdrop className={classes.backdrop} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}

      </footer>
    </div>
  );
};

Footer.propTypes = {
  locale: PropTypes.string,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentlySending: PropTypes.bool,
  isQuotesExpanded: PropTypes.bool,
  getAccountData: PropTypes.func,
  featureList: PropTypes.arrayOf(PropTypes.object),
  availableLocales: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = state => ({
  featureList: state.defaultReducer.featureList
});

export default connect(mapStateToProps)(Footer);
